
import { login } from '../../redux';
import axios, { AxiosRequestConfig } from "axios";

const loginApi = async(UserId:string,Password:string,resolve:any,reject:any)=>{
    let data = {"userName":UserId,"password":Password};

    let config:AxiosRequestConfig = {
     method: 'post',
     url: 'https://api.sht.distronix.in:4443/api/users/login',
     headers: { 
       'Content-Type': 'application/json'
     },
     data : data
   };
   
   axios(config)
   const result = await axios(config)
   .then((res) => {

       resolve(true)
       return res.data
   })
   .catch((e) => reject(Error(e.message)));
   console.log(result)
   return result
}

export const getFreshToken = async (UserId: string, Password: string): Promise<boolean> => {
    //This function needs to be implemented after the API is provided.
    //Currently Mocking the API call.
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (UserId === 'Admin' && Password === 'Password') resolve(true);
            else reject(Error("Credentials are invalid."));
    }, 1000);
    // loginApi(UserId,Password,resolve,reject)

    })
    
}
